import AboutMeContainer from "../components/AboutMe/AboutMeContainer";

export default function AboutMe() {
  return (
    <AboutMeContainer/>
  );
}
